/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Record_Actions_LabelInputs */

const en_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record actions`)
};

const fr_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions d'enregistrement`)
};

const de_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktionen aufzeichnen`)
};

const it_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registra le azioni`)
};

const ru_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись действий`)
};

const es_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrar acciones`)
};

const zh_cn2_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`记录操作`)
};

const ja_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクションを記録する`)
};

const hi_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड क्रियाएँ`)
};

const pt_pt2_explorer_info_record_actions_label = /** @type {(inputs: Explorer_Info_Record_Actions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ações de registro`)
};

/**
* | output |
* | --- |
* | "Record actions" |
*
* @param {Explorer_Info_Record_Actions_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_record_actions_label = /** @type {((inputs?: Explorer_Info_Record_Actions_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Record_Actions_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_record_actions_label(inputs)
	if (locale === "de") return de_explorer_info_record_actions_label(inputs)
	if (locale === "it") return it_explorer_info_record_actions_label(inputs)
	if (locale === "ru") return ru_explorer_info_record_actions_label(inputs)
	if (locale === "es") return es_explorer_info_record_actions_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_record_actions_label(inputs)
	if (locale === "ja") return ja_explorer_info_record_actions_label(inputs)
	if (locale === "hi") return hi_explorer_info_record_actions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_record_actions_label(inputs)
	return en_explorer_info_record_actions_label(inputs)
});